import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
      <div className="min-w-0">
        <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-50 flex items-center gap-2">
          <span className="w-1 h-5 md:h-7 rounded-full bg-primary-500 inline-block" />
          {title}
        </h2>
        {subtitle && <p className="text-xs md:text-sm text-foreground-500 mt-2">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 inline-flex items-center gap-1 text-xs md:text-sm text-foreground-400 hover:text-accent-500 transition-colors whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line" />
        </Link>
      )}
    </div>
  );
}